import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export function initHeaderScroll() {
  const header = document.querySelector('.siteHeader');
  let headerHeight = header.offsetHeight;
  let headerPadding = parseFloat(getComputedStyle(header).paddingTop) || 0;
  let headerScrollTrigger = null; // Store reference to header-specific ScrollTrigger

  function setupHeaderBehavior() {
    // Clear any existing classes first
    document.body.classList.remove('header-visible', 'header-fixed', 'header-short', 'header-opaque');
    
    if (window.matchMedia('(min-width: 1280px)').matches) {
      // Desktop behavior
      // Initial state
      if (window.scrollY <= headerHeight) {
        document.body.classList.add('header-visible');
      }

      // Main scroll trigger for header behavior
      headerScrollTrigger = ScrollTrigger.create({
        trigger: document.body,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: (self) => {
          const currentScrollY = self.scroll();
          const scrollingDown = self.direction === 1;
          const scrollingUp = self.direction === -1;

          // SCROLL DOWN - Hide header
          if (scrollingDown && currentScrollY > headerHeight + headerPadding) {
            document.body.classList.remove('header-visible');
            document.body.classList.add('header-fixed');
            document.body.classList.add('header-short');
            document.body.classList.remove('header-opaque');
          }

          // RESET AT TOP
          if (currentScrollY <= 55) {
            document.body.classList.remove('header-fixed');
            document.body.classList.remove('header-short');
            document.body.classList.add('header-visible');
          }
          if (currentScrollY <= headerHeight) {
            document.body.classList.remove('header-opaque');
          }

          // SCROLL UP - Show header
          if (scrollingUp && currentScrollY > headerHeight) {
            document.body.classList.add('header-visible');
            document.body.classList.add('header-opaque');
          }
        }
      });
    } else {
      // Mobile behavior
      // Initial state
      if (window.scrollY > 20) {
        document.body.classList.add('header-opaque');
        document.body.classList.add('header-short');
      } else {
        document.body.classList.remove('header-opaque');
        document.body.classList.remove('header-short');
      }

      // Mobile scroll trigger
      headerScrollTrigger = ScrollTrigger.create({
        trigger: document.body,
        start: 'top top',
        end: 'bottom bottom',
        onUpdate: (self) => {
          const currentScrollY = self.scroll();
          
          if (currentScrollY > 10) {
            document.body.classList.add('header-opaque');
            document.body.classList.add('header-short');
          } else {
            document.body.classList.remove('header-opaque');
            document.body.classList.remove('header-short');
          }
        }
      });
    }
  }

  // Initial setup
  setupHeaderBehavior();

  // Re-setup on window resize with debouncing to prevent iOS scroll issues
  let resizeTimeout;
  window.addEventListener('resize', () => {
    // Clear existing timeout
    clearTimeout(resizeTimeout);
    
    // Debounce resize events to prevent excessive re-setup on iOS
    resizeTimeout = setTimeout(() => {
      // Only kill the header-specific ScrollTrigger
      if (headerScrollTrigger) {
        headerScrollTrigger.kill();
        headerScrollTrigger = null;
      }
      
      // Recalculate header dimensions
      headerHeight = header.offsetHeight;
      headerPadding = parseFloat(getComputedStyle(header).paddingTop) || 0;
      
      // Re-setup with new dimensions
      setupHeaderBehavior();
    }, 150); // 150ms debounce delay
  });
}
